import { Navigate, useParams } from "react-router";
import useSWR from "swr";
import { simpleFetcher } from "~/api/fetcher";
import { useDocumentVersions } from "~/api/v2/useDocumentVersions";
import { CenterSpinner } from "~/atoms/spinner";
import { DocumentVersionStatus } from "~/config/types";
import NoResult from "~/molecules/NoResult";

const url = "/api/v2/documents/get-id";

const ProjectPage = () => {
  const { projectId } = useParams();

  const { data, isLoading } = useSWR<{ documentId: number }>(
    `${url}/${projectId}`,
    simpleFetcher,
  );

  const { data: publishedDocumentVersions, isLoading: isLoadingVersions } =
    useDocumentVersions({
      statuses: [DocumentVersionStatus.published],
      documentId: data?.documentId,
    });

  const latestPublishedVersion = publishedDocumentVersions
    ?.filter((dv) => dv.publishedAt != null)
    .sort((a, b) => {
      const dateA = a.publishedAt ? new Date(a.publishedAt).getTime() : 0;
      const dateB = b.publishedAt ? new Date(b.publishedAt).getTime() : 0;
      return dateB - dateA;
    })[0];

  if (isLoading || isLoadingVersions) {
    return <CenterSpinner />;
  }

  if (!data) {
    return <NoResult />;
  }

  const targetPath = latestPublishedVersion
    ? `/documents/${data.documentId}?versionId=${latestPublishedVersion.id}`
    : `/documents/${data.documentId}`;

  return <Navigate to={targetPath} replace />;
};

export default ProjectPage;
